import React, { useState, useEffect, useContext } from "react";
import BranchContext from "../context/branch";
import FontAwesome from "react-fontawesome";
import Select from "../common/select";
import _ from "lodash";
// import Headertruck from "./../queue/headertruck"
import Modaleditqueue from "./../queue/modalconfigqueue";
import {
  GetprivilegePage,
  getQueueConfig,productgroup,
  getQueueMonitor,
  getqueuedetail,getProductGroup
} from "../../services/wms";
import moment from "moment";
import DatePicker from "react-datepicker";
import Header from "../common/headerlist";
import Renderdata from "./card";
import ModalDetial from "./modaldetail";
// import Headerreport from "../wms/headerreport";
// import ReportCreate from "../chart/reportCreator";
import { toast } from "react-toastify";

const QueueMonitor = (props) => {
 
  const [ruckid, setruckid] = useState(0);
  const [proid, setproid] = useState(0);
  const [id, setid] = useState(0);
  const [queueid, setqueueid] = useState(0);
  const [startDate, setstartDate] = useState(new Date());
  const [queuelist, setqueuelist] = useState([]);
  const [queueconfig, setqueueconfig] = useState([]);
  const [editlist, seteditlist] = useState({});
  const [currenttime, setcurrenttime] = useState("");
  const { currentBranch } = useContext(BranchContext);
  const [isOpen, setisOpen] = useState(false);
  const [isConfigOpen, setisConfigOpen] = useState(false);
  const [list, setlist] = useState([]);
  const [queuedetail, setqueuedetail] = useState([]);
  const [productgrouplist, setproductgrouplist] = useState([]);
  const [onProgress, setonProgress] = useState(false);
  const [loading, setloading] = useState(false);
  const [ckPermit, setckPermit] = useState(false);

  const [total, settotal] = useState({
    all: 0,
    truckin: 0,
    waiting: 0,
    truckout: 0,
    over: 0,
    cancel: 0,
  });
  const [trucklist, settrucklist] = useState([
    { _id: 0, name: "ทั้งหมด", classname: "btn btn-primary" },
    { _id: 1, name: "รถบริษัท", classname: "btn btn-outline-dark" },
    { _id: 2, name: "รถลูกค้า", classname: "btn btn-outline-dark" },
  ]);

  useEffect(() => {
    if (!currentBranch) return;
    if (currentBranch._id === "0" || currentBranch._id === "") return;
    const loadPrivilege = async () => {
      const { data: result } = await GetprivilegePage(
        "/queuelist",
        currentBranch._id
      );
      if (result.status === "success") {
        setckPermit(true);
      } else if (result.status === "error") {
        setckPermit(false);
        // toast.error(result.message);
      }
    };
    loadPrivilege();
  }, [currentBranch]);

  useEffect(() => {
    if (!currentBranch) return;
    if (
      currentBranch._id === "0" ||
      currentBranch._id === "" ||
      currentBranch._id !== "503"
    )
      return;
    if (!ckPermit) return;
    setonProgress(true);
    const loadData = async () => {
      const { data: result } = await getQueueConfig(currentBranch._id);

      if (result) {
        setonProgress(false);
        setqueueconfig(result);
      }
    };
    loadData();
  }, [currentBranch,  ckPermit]);

  useEffect(() => {
    if (!currentBranch) return;
    if (currentBranch._id === "0" || currentBranch._id === "") return;
    if (!ckPermit) return;
    setonProgress(true);
    const loadData = async () => {
      const { data: result } = await productgroup(currentBranch._id);
      if (result) {
        setonProgress(false);
        setlist(result);
      }
    };
    loadData();
  }, [currentBranch, ckPermit]);

  useEffect(() => {
    if (!currentBranch) return;
    if (
      currentBranch._id === "0" ||
      currentBranch._id === "" ||
      currentBranch._id !== "503"
    )
    if (!ckPermit) return;
    if(proid!==5) return

    setonProgress(true);
    const loadData = async () => {
      const { data: result } = await getProductGroup(currentBranch._id);
      if (result.status === "success") {
        setonProgress(false);
        setproductgrouplist(result.data.list);
      }
    };
    loadData();
  }, [currentBranch, ckPermit,proid]);


  useEffect(() => {
    if (!currentBranch) return;
    if (
      currentBranch._id === "0" ||
      currentBranch._id === "" ||
      currentBranch._id !== "503"
    )
      return;
    if (!ckPermit) return;
    setonProgress(true);
    const loadData = async () => {
      const { data: result } = await getqueuedetail(queueid, currentBranch._id);
      if (result.status === "success") {
        setonProgress(false);
        setqueuedetail(result.data.list);
      }
    };
    loadData();
  }, [currentBranch, queueid, ckPermit]);


 
  useEffect(() => {
    if (!currentBranch) return;
   
    if (
      currentBranch._id === "0" ||
      currentBranch._id === "" ||
      currentBranch._id !== "503"
    )
  return;
    if (!ckPermit) return;

    setloading(true);
    const loadPrivilege = async () => {
      const { data: result } = await getQueueMonitor(
        currentBranch._id,
        moment(startDate, "YYYY-MM-DD").add(0, "day").format("YYYY-MM-DD"),
        proid,
        ruckid,id
      );
      if (result.status === "success") {
        setqueuelist(result.data.list);
        setcurrenttime(result.data.current);

        settotal({
          all:
            result.data.total.id0 +
            result.data.total.id1 +
            result.data.total.id2 +
            result.data.total.id3 +
            result.data.total.id4,
          truckin: result.data.total.id1,
          waiting: result.data.total.id0,
          truckout: result.data.total.id2,
          over: result.data.total.id3,
          cancel: result.data.total.id4,
        });

        setloading(false);
      } else if (result.status === "error") {
        toast.error(result.message);
        setloading(false);
      }
    };
    loadPrivilege();
  }, [currentBranch,  startDate, id,proid, ruckid, ckPermit]);

  const handleChange = ({ name, item, classname }) => {
    const clear = [...list];

    const index1 = clear.findIndex((x) => x.classname === "btn btn-primary");
    if (index1 > -1) {
      clear[index1].classname = "btn btn-outline-dark";
      setlist(clear);
    }
    const subobject = {
      _id: item,
      name: name,
      classname: "btn btn-primary",
    };
    const sub = [...list];
    const index = sub.findIndex((x) => x._id === item);
    sub[index] = subobject;
    setlist(sub);
    setproid(item);
  };

  const handleChangeTruck = ({ name, item, classname }) => {
    const clear = [...trucklist];

    const index1 = clear.findIndex((x) => x.classname === "btn btn-primary");
    if (index1 > -1) {
      clear[index1].classname = "btn btn-outline-dark";
      settrucklist(clear);
    }
    const subobject = {
      _id: item,
      name: name,
      classname: "btn btn-primary",
    };
    const sub = [...trucklist];
    const index = sub.findIndex((x) => x._id === item);
    sub[index] = subobject;
    settrucklist(sub);
    setruckid(item);
  };

  const handleProductChange = (event) => {
    setproid(event);
  };
  const handleChangStartDate = (event) => {
    setstartDate(event);
  };

  const handleConfirm = () => {
    setisOpen(false);
  };
  const handleCancel = () => {
    setisOpen(false);
  };
  const handelClick = (id) => {  
    if (id===1){
      seteditlist(_.find(queueconfig, function(x) { return x._id === id ;})); 
      setisConfigOpen(true);
    }
  }
  const onConfirm = () => {
    setisConfigOpen(false);
  }
  const onCancel = () => {
  setisConfigOpen(false);
  }
  const handleonClick = (id, queueid) => {
    setqueueid(queueid);
    setisOpen(true);
  };
  const handleChangeProduct = (event) => {
      setid(event.currentTarget.value)
  }

  if (!ckPermit) return <></>;

  //  if (currentBranch && currentBranch._id !=="503")  {
  //    console.log(currentBranch)
  //   toast.error("ยังไม่เปิดใช้ในสาขานี้");
  // }
  return (
    <>
     <Modaleditqueue
        isOpen={isConfigOpen}
        onConfirm={onConfirm}
        onCancel={onCancel}
        header ={"แก้ไขจำนวนรถต่อชั่วโมง"}
        list={editlist}
      />
      <ModalDetial
        isOpen={isOpen}
     
        onConfirm={handleConfirm}
        onCancel={handleCancel}
        list={queuedetail}
      />
      <div className="container-fluid">
        <div className="row">
          <div className="col-auto">
           <i>
              วันที่ 
            </i>

            <div className="mt-1" style={{ marginTop: 20, marginBottom: 20 }}>
              <DatePicker
 className="datepicker-default form-control"
                todayButton="Today"
                dateFormat="dd/MM/yyyy"
                selected={startDate}
                onChange={handleChangStartDate}
              />
            </div>
          </div>

          <div className="col-auto">
           <i>
              กลุ่มสินค้า 
            </i>

            <Header list={list} onChange={handleChange} disabled={loading} />
            {productgrouplist.length > 0 && proid===5 ?   <div className ="mb-2">
                    <Select
                      options={productgrouplist}
                      label={"สินค้า"}
                      value={id}                 
                      onChange={handleChangeProduct}                  
                    />
                  </div> 
            
            
            :null}
          </div>
          <div className="col-auto ms-1">
           <i>
              กลุ่มรถบรรทุก
            </i>
           
              <Header
                list={trucklist}
                onChange={handleChangeTruck}
                disabled={loading}
              />
          
          </div>
        </div>
        <div className="card text-center border-secondary">

          <div className="card-mb-1 d-flex align-items-center justify-content-center h-100 bg-info">
            <FontAwesome name="truck"> </FontAwesome> จำนวนรถต่อชั่วโมง
          </div>
          <div className="card-body">
            <div className="row ms-1">

                            
              {queueconfig && queueconfig.length > 0 && queueconfig.map((item, index) => 
               <div className="col-auto mb-2" key ={index}>
                <FontAwesome name="cog"
                 onClick={() => handelClick(item._id)}
                > </FontAwesome> {"  "}
                <span                
                  style={{ fontSize: "14px"}}
                >
                  {item.name}            
                </span>
                <span 
                  onClick={() => handelClick(item._id)}
                  className="badge rounded-pill bg-secondary ms-1"               
                  style={{ fontSize: "14px", cursor: "pointer" }}
                >              
                  {item.cust_perHr}   
                 
                  {" / "}          
                  {item.queumax}   
                 
                </span>
              </div>
              ) }

              {/* <div className="col-auto mb-2">
                <FontAwesome name="cog"> </FontAwesome> {"  "}
                <span
                  className="badge rounded-pill bg-primary"
                  style={{ fontSize: "15px", cursor: "pointer" }}
                >
                  {"รถบริษัท"}  20  {"คัน"}
                </span>
              </div> */}
            </div>
          </div>
          
        </div>
        <div className="row mt-2">
          <div className="col-auto mb-2">
            <span
              className="badge rounded-pill    bg-warning text-dark"
              style={{ fontSize: "13px", cursor: "pointer" }}
            >
              {"รอชั่ง"} {total.waiting}
            </span>
          </div>
          <div className="col-auto mb-2">
            <span
              className="badge rounded-pill   bg-success"
              style={{ fontSize: "13px", cursor: "pointer" }}
            >
              {"ชั่งเข้า"} {total.truckin}
            </span>
          </div>
          <div className="col-auto mb-2">
            <span
              className="badge rounded-pill   bg-info text-dark"
              style={{ fontSize: "13px", cursor: "pointer" }}
            >
              {"ชั่งออก"} {total.truckout}
            </span>
          </div>
          <div className="col-auto mb-2">
            <span
              className="badge rounded-pill   bg-danger"
              style={{ fontSize: "13px", cursor: "pointer" }}
            >
              {"ตกคิว"} {total.over}
            </span>
          </div>
          <div className="col-auto mb-2">
            <span
              className="badge rounded-pill    bg-secondary"
              style={{ fontSize: "13px", cursor: "pointer" }}
            >
              {"ยกเลิก"} {total.cancel}
            </span>
          </div>
          <div className="col-auto mb-2">
            <span
              className="badge rounded-pill   bg-primary"
              style={{ fontSize: "13px", cursor: "pointer" }}
            >
              {"Total"} {total.all}
            </span>
          </div>
        </div>

         <Renderdata
          list={queuelist}
          current={currenttime}
          handleonClick={handleonClick}
        />
      </div>
    </>
  );
};

export default QueueMonitor;
